<template>
  <div class="index">
    <!-- banner -->
    <div class="banner">
      <div class="banner-content">
        <h1>科技资讯前沿</h1>
        <p>掌握最新科技动态，洞察行业发展趋势</p>

      </div>
      <img src="/imgs/b1.jpg" alt="" />
    </div>

    <!-- 顶宽布局 -->
    <div class="container">


      <!-- 热门资讯 -->
      <div class="hot-news">
        <div class="section-header">
          <h2>今日热点</h2>
          <a href="#" class="more-link">更多 &gt;</a>
        </div>
        <div class="hot-news-grid">
          <div class="hot-news-item main-news" @click="gopay">
            <div class="news-tag">热门</div>
            <img src="/imgs/info2/1.jpg" alt="热门新闻">
            <div class="news-content">
              <h3>人工智能技术突破，新型算法大幅提升数据处理效率</h3>
              <p>最新研究表明，新型AI算法在处理大规模数据时效率提升300%...</p>
              <div class="news-meta">
              
              </div>
            </div>
          </div>

          <div class="hot-news-list">
            <div class="hot-list-item" v-for="(item, index) in ac2" :key="item" @click="gopay">
              <span class="hot-index">{{ index + 1 }}</span>
              <div class="hot-content">
                <h4>{{ item.title }}</h4>
                <div class="news-meta">
                  <span>付费资讯</span>
                  <span>2元/条</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 关于我们区块 -->
      <div class="us">
        <!-- 标题 -->
        <div class="section-header">
          <h2>关于我们</h2>
          <div class="section-subtitle">ABOUT US</div>
        </div>

        <!-- 容器 -->
        <div class="us-con">
          <!-- 左侧 -->
          <div class="us-l">
            <img src="/imgs/info.jpg" alt="" />
           
          </div>

          <!-- 右侧 -->
          <div class="us-r">
            <h2>京游科技（北京）有限公司</h2>
            <div class="company-tags">
              <span class="company-tag">技术创新</span>
              <span class="company-tag">专业服务</span>
              <span class="company-tag">品质保证</span>
            </div>
            <p>
             京游科技（北京）有限公司成立于2017年04月19日，注册地位于北京市房山区良乡长虹西路翠柳东街1号-4468
            </p>

            <p>
             经营范围包括互联网信息服务；从事互联网文化活动；技术开发、技术推广、技术转让、技术咨询、技术服务；计算机系统服务；基础软件服务、应用软件服务；软件开发；软件咨询；产品设计；模型设计；包装装潢设计；教育咨询（中介服务除外）；经济贸易咨询；文化咨询；体育咨询；公共关系服务；会议服务；工艺美术设计；电脑动画设计；企业策划、设计；设计、制作、代理、发布广告；市场调查；企业管理咨询；组织文化艺术交流活动（不含营业性演出）；文艺创作；承办展览展示活动；会议服务；影视策划；翻译服务；自然科学研究与试验发展；工程和技术研究与试验发展；农业科学研究与试验发展；医学研究与试验发展；数据处理（数据处理中的银行卡中心、PUE值在1.5以上的云计算数据中心除外）。（企业依法自主选择经营项目，开展经营活动；依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。）
            </p>
         
          </div>
        </div>
      </div>

      <!-- 资讯推荐区块 -->
      <div class="recommend-news">
        <div class="section-header">
          <h2>编辑推荐</h2>
          <a href="#" class="more-link">更多推荐 &gt;</a>
        </div>
        <div class="recommend-grid">
          <!-- 循环项 -->
          <div class="recommend-card" v-for="item in ac1" :key="item" @click="gopay">
            <div class="card-image">
              <img :src="item.img" alt="推荐资讯">
              <div class="card-tag">推荐</div>
            </div>
            <div class="card-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.jj }}</p>
              <div class="card-meta">
                <div class="meta-left">
                  <span class="author">付费资讯-2元/条</span>
                  <span class="date">2025-10-15</span>
                </div>
                <div class="meta-right">
                  <span class="views">2.5k阅读</span>
                  <span class="likes">186赞</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 重构：收费资讯区块 -->
      <div class="premium-info">
        <div class="section-header">
          <h2>精品付费内容</h2>
          <div class="section-subtitle">PREMIUM CONTENT</div>
        </div>

        <div class="premium-container">
          <!-- 主推付费文章 -->
          <div class="featured-premium">
            <div class="premium-badge">深度报告</div>
            <img src="/imgs/ct1.jpg" alt="付费内容">
            <div class="premium-content">
              <div class="premium-header">
                <h3>从"马蜂窝数据事件"谈软件开发的领域约束与系统设计</h3>
                <div class="premium-price">
                  <span class="price-amount">¥2</span>
                  <span class="price-desc">解锁全文</span>
                </div>
              </div>
              <p class="premium-excerpt">
                在设计软件系统时，领域知识往往是最重要的，而领域知识的一大部分就在于识别领域中的各种约束。这些约束很难由产品经理巨细靡遗地穷举出来，而必须由参与开发的所有人达成共识，在系统里实现它。但是无论如何，这些约束都是必不可少的，没有它们，系统就很可能出现各种稀奇古怪的现象...
              </p>
              <div class="premium-features">
                <span class="feature-item">📊 深度数据分析</span>
                <span class="feature-item">🔍 独家行业洞察</span>
                <span class="feature-item">💡 实用解决方案</span>
              </div>
              <div class="premium-meta">
                <div class="meta-info">
                  <span class="author">资深技术架构师</span>
                  <span class="read-time">阅读时长: 15分钟</span>
                  <span class="level">进阶内容</span>
                </div>
                <button class="purchase-btn" @click="gopay">
                  <span>立即购买</span>
                  <i class="icon-lock"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- 付费文章列表 -->
          <div class="premium-list">
            <div class="premium-list-header">
              <h4>更多付费内容</h4>
              <div class="sort-options">
                <span class="sort-active">最新</span>
                <!-- <span>热门</span>
                <span>评分</span> -->
              </div>
            </div>

            <div class="premium-articles">
              <div class="premium-article-item" v-for="(item, index) in this.mAc" :key="index"
                @click="goDays(item.methods, item.id)">
                <div class="article-main">
                  <div class="article-info">
                    <h5>{{ item.title }}</h5>
                    <div class="article-tags">
                      <span class="tag-expert">专家解读</span>
                      <span class="tag-length">深度长文</span>
                    </div>
                    <div class="article-stats">
                      <span class="stat-item">👁️ 1.2k人已购</span>
                      <span class="stat-item">⭐ 4.8分</span>
                    </div>
                  </div>
                  <div class="article-price">
                    <div class="price-badge">¥2</div>
                    <button class="buy-btn">购买</button>
                  </div>
                </div>
                <div class="article-preview">
                  <p>本文深入分析了当前行业趋势，提供了实用的解决方案和前瞻性的观点...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal title="请付款阅读" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img src="/imgs/pay.png" />
        <h2>微信支付：2元/条</h2>
      </template>
    </modal>
  </div>
</template>

<script>
// import navigation from "./../components/navigation";
import Modal from "./../components/Modal.vue";
export default {
  components: { Modal },
  data() {
    return {
      href: "index.html",
      ac1: [],
      ac2: [],
      ac3: [],
      ac: [],
      myData: [],
      mAc: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "京游科技（北京）有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/ac.json").then((res) => {
        const data = res.data;
        this.mAc = data.slice(0, 4);
      });
      this.axios.get("/mock/index.json").then((res) => {
        const data = res.data;
        this.ac1 = data.slice(0, 4);
        this.ac2 = data.slice(4, 8);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      alert("资讯每条2元/条，点击确定购买");
      this.showModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.index {
  background: #f5f7fa;
  min-height: 100vh;

  //  banner
  .banner {
    position: relative;
    width: 100%;
    height: 500px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 10%;
      transform: translateY(-50%);
      color: white;
      z-index: 2;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

      h1 {
        font-size: 48px;
        font-weight: 700;
        margin-bottom: 16px;
      }

      p {
        font-size: 20px;
        margin-bottom: 30px;
        opacity: 0.9;
      }

      .search-box {
        display: flex;
        width: 500px;

        input {
          flex: 1;
          padding: 15px 20px;
          border: none;
          border-radius: 8px 0 0 8px;
          font-size: 16px;
          outline: none;
        }

        button {
          padding: 15px 30px;
          background: #1890ff;
          color: white;
          border: none;
          border-radius: 0 8px 8px 0;
          cursor: pointer;
          font-size: 16px;
          font-weight: 600;
          transition: background 0.3s;

          &:hover {
            background: #40a9ff;
          }
        }
      }
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    // 快速导航
    .quick-nav {
      display: flex;
      justify-content: center;
      gap: 40px;
      margin: 40px 0;
      padding: 30px 0;
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

      .nav-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        transition: transform 0.3s;

        &:hover {
          transform: translateY(-5px);
        }

        .nav-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 10px;

          &.tech {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          &.finance {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }

          &.industry {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }

          &.startup {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }

          &.policy {
            background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
          }
        }

        span {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }
      }
    }

    // 通用标题样式
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 60px 0 40px;
      padding-bottom: 15px;
      border-bottom: 2px solid #e8e8e8;

      h2 {
        font-size: 28px;
        font-weight: 700;
        color: #333;
        margin: 0;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -17px;
          left: 0;
          width: 60px;
          height: 3px;
          background: #1890ff;
        }
      }

      .section-subtitle {
        font-size: 14px;
        color: #999;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      .more-link {
        color: #1890ff;
        text-decoration: none;
        font-weight: 500;
        transition: color 0.3s;

        &:hover {
          color: #40a9ff;
        }
      }
    }

    // 热门资讯
    .hot-news {
      .hot-news-grid {
        display: grid;
        grid-template-columns: 2fr 1fr;
        gap: 30px;
      }

      .main-news {
        position: relative;
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s;

        &:hover {
          transform: translateY(-5px);
        }

        .news-tag {
          position: absolute;
          top: 15px;
          left: 15px;
          background: #ff4d4f;
          color: white;
          padding: 5px 12px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          z-index: 2;
        }

        img {
          width: 100%;
          height: 280px;
          object-fit: cover;
        }

        .news-content {
          padding: 25px;

          h3 {
            font-size: 22px;
            font-weight: 700;
            color: #333;
            margin-bottom: 15px;
            line-height: 1.4;
          }

          p {
            color: #666;
            line-height: 1.6;
            margin-bottom: 20px;
          }

          .news-meta {
            display: flex;
            gap: 20px;
            font-size: 12px;
            color: #999;

            span {
              display: flex;
              align-items: center;

              &::before {
                content: '•';
                margin-right: 5px;
              }
            }
          }
        }
      }

      .hot-news-list {
        display: flex;
        flex-direction: column;
        gap: 15px;
      }

      .hot-list-item {
        display: flex;
        align-items: flex-start;
        background: white;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        transition: all 0.3s;
        cursor: pointer;

        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transform: translateX(5px);
        }

        .hot-index {
          width: 24px;
          height: 24px;
          background: #ff4d4f;
          color: white;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 600;
          margin-right: 15px;
          margin-top: 2px;
        }

        .hot-content {
          flex: 1;

          h4 {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 8px;
            line-height: 1.4;
          }

          .news-meta {
            display: flex;
            gap: 15px;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }

    // 关于我们区块
    .us {
      .us-con {
        display: grid;
        grid-template-columns: 1fr 1.2fr;
        gap: 40px;
        align-items: start;
      }

      .us-l {
        position: relative;

        img {
          width: 100%;
          height: 400px;
          object-fit: cover;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .company-stats {
          position: absolute;
          bottom: -30px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-around;
          background: white;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

          .stat-item {
            text-align: center;

            .stat-number {
              font-size: 32px;
              font-weight: 700;
              color: #1890ff;
              margin-bottom: 5px;
            }

            .stat-label {
              font-size: 14px;
              color: #666;
            }
          }
        }
      }

      .us-r {
        background: white;
        padding: 40px;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        h2 {
          font-size: 28px;
          font-weight: 700;
          color: #333;
          margin-bottom: 20px;
        }

        .company-tags {
          display: flex;
          gap: 10px;
          margin-bottom: 25px;

          .company-tag {
            background: #e6f7ff;
            color: #1890ff;
            padding: 6px 12px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 500;
          }
        }

        p {
          color: #666;
          line-height: 1.8;
          margin-bottom: 20px;
          text-align: justify;
        }

        .contact-info {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #f0f0f0;

          .contact-item {
            display: flex;
            margin-bottom: 10px;
            font-size: 14px;

            .contact-label {
              color: #333;
              font-weight: 500;
              min-width: 50px;
            }

            span:last-child {
              color: #666;
            }
          }
        }
      }
    }

    // 资讯推荐区块
    .recommend-news {
      .recommend-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 30px;
      }

      .recommend-card {
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transition: all 0.3s;
        cursor: pointer;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .card-image {
          position: relative;
          height: 200px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s;
          }

          .card-tag {
            position: absolute;
            top: 15px;
            left: 15px;
            background: #ff7a45;
            color: white;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 600;
          }
        }

        .card-content {
          padding: 25px;

          h3 {
            font-size: 18px;
            font-weight: 700;
            color: #333;
            margin-bottom: 12px;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          p {
            color: #666;
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .card-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #999;

            .meta-left,
            .meta-right {
              display: flex;
              gap: 15px;
            }

            .views,
            .likes {
              display: flex;
              align-items: center;
            }
          }
        }

        &:hover .card-image img {
          transform: scale(1.05);
        }
      }
    }

    // 重构：收费资讯区块
    .premium-info {
      .premium-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 40px;
        align-items: start;
      }

      .featured-premium {
        background: white;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        position: relative;
        transition: transform 0.3s;

        &:hover {
          transform: translateY(-5px);
        }

        .premium-badge {
          position: absolute;
          top: 20px;
          left: 20px;
          background: linear-gradient(135deg, #ff6b6b, #ee5a52);
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 700;
          z-index: 2;
          box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
        }

        img {
          width: 100%;
          height: 280px;
          object-fit: cover;
        }

        .premium-content {
          padding: 30px;

          .premium-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 20px;

            h3 {
              font-size: 22px;
              font-weight: 700;
              color: #333;
              line-height: 1.4;
              flex: 1;
              margin-right: 20px;
            }

            .premium-price {
              text-align: center;
              background: linear-gradient(135deg, #ffd666, #ffa940);
              padding: 12px 16px;
              border-radius: 12px;
              min-width: 100px;

              .price-amount {
                display: block;
                font-size: 24px;
                font-weight: 800;
                color: #d46b08;
              }

              .price-desc {
                display: block;
                font-size: 12px;
                color: #d46b08;
                font-weight: 600;
              }
            }
          }

          .premium-excerpt {
            color: #666;
            line-height: 1.7;
            margin-bottom: 25px;
            font-size: 15px;
          }

          .premium-features {
            display: flex;
            gap: 15px;
            margin-bottom: 25px;
            flex-wrap: wrap;

            .feature-item {
              background: #f0f7ff;
              color: #1890ff;
              padding: 6px 12px;
              border-radius: 15px;
              font-size: 12px;
              font-weight: 500;
            }
          }

          .premium-meta {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 20px;
            border-top: 1px solid #f0f0f0;

            .meta-info {
              display: flex;
              gap: 20px;
              font-size: 13px;
              color: #999;

              .author {
                color: #333;
                font-weight: 500;
              }

              .level {
                background: #fff7e6;
                color: #d46b08;
                padding: 2px 8px;
                border-radius: 10px;
                font-size: 11px;
              }
            }

            .purchase-btn {
              background: linear-gradient(135deg, #1890ff, #096dd9);
              color: white;
              border: none;
              padding: 12px 24px;
              border-radius: 8px;
              font-weight: 600;
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 8px;
              transition: all 0.3s;
              box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);

              &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4);
              }

              .icon-lock {
                font-size: 14px;
              }
            }
          }
        }
      }

      .premium-list {
        background: white;
        border-radius: 16px;
        padding: 30px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);

        .premium-list-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
          padding-bottom: 15px;
          border-bottom: 1px solid #f0f0f0;

          h4 {
            font-size: 20px;
            font-weight: 700;
            color: #333;
            margin: 0;
          }

          .sort-options {
            display: flex;
            gap: 20px;
            font-size: 13px;
            color: #999;

            span {
              cursor: pointer;
              padding: 4px 8px;
              border-radius: 6px;
              transition: all 0.3s;

              &.sort-active {
                background: #1890ff;
                color: white;
              }

              &:hover:not(.sort-active) {
                color: #1890ff;
              }
            }
          }
        }

        .premium-articles {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .premium-article-item {
          background: #fafafa;
          border-radius: 12px;
          padding: 20px;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid #f0f0f0;

          &:hover {
            background: white;
            border-color: #e6f7ff;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
            transform: translateX(5px);
          }

          .article-main {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 15px;
          }

          .article-info {
            flex: 1;

            h5 {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              margin-bottom: 10px;
              line-height: 1.4;
            }

            .article-tags {
              display: flex;
              gap: 8px;
              margin-bottom: 12px;

              .tag-expert,
              .tag-length {
                font-size: 10px;
                padding: 3px 8px;
                border-radius: 10px;
                font-weight: 500;
              }

              .tag-expert {
                background: #f6ffed;
                color: #52c41a;
                border: 1px solid #b7eb8f;
              }

              .tag-length {
                background: #fff7e6;
                color: #fa8c16;
                border: 1px solid #ffd591;
              }
            }

            .article-stats {
              display: flex;
              gap: 15px;
              font-size: 11px;
              color: #999;

              .stat-item {
                display: flex;
                align-items: center;
              }
            }
          }

          .article-price {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;

            .price-badge {
              background: linear-gradient(135deg, #ff7875, #ff4d4f);
              color: white;
              padding: 6px 12px;
              border-radius: 15px;
              font-size: 14px;
              font-weight: 700;
              min-width: 50px;
              text-align: center;
            }

            .buy-btn {
              background: #1890ff;
              color: white;
              border: none;
              padding: 6px 16px;
              border-radius: 6px;
              font-size: 12px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: #40a9ff;
                transform: translateY(-1px);
              }
            }
          }

          .article-preview {
            p {
              font-size: 13px;
              color: #666;
              line-height: 1.5;
              margin: 0;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>